// store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import userReducer from "./features/user/userSlice";
import projectReducer from "./features/project/projectSlice";
import workPackageReducer from "./features/workPackage/workPackageSlice";
import taskReducer from "./features/task/taskSlice";
import deliverableReducer from "./features/deliverable/deliverableSlice";
import meetingReducer from "./features/meeting/meetingSlice";
import resourceAllocationReducer from "./features/resourceAllocation/resourceAllocationSlice";
import locationReducer from "./features/location/locationSlice";
import notifiationReducer from "./features/notification/notificationSlice";
import dashboardReducer from "./features/dashboard/dashboardSlice";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // uses localStorage
import { combineReducers } from "redux";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // specify which slices you want to persist
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  projects: projectReducer,
  workPackages: workPackageReducer,
  tasks: taskReducer,
  deliverables: deliverableReducer,
  meetings: meetingReducer,
  resourceAllocations: resourceAllocationReducer,
  location: locationReducer,
  notifications: notifiationReducer,
  dashboard: dashboardReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

export const persistor = persistStore(store);
